import styled from 'styled-components'
import {airBlue, seaNavy, landGreen, lightGray, warning} from '@modifi/colors'

const backgroundColor = ({$status}: {$status?: string}): string => {
  switch ($status) {
    case 'COMPLETED':
      return landGreen
    case 'WARNING':
      return warning
    default:
      return `linear-gradient(90deg, ${airBlue} 64.38%, ${seaNavy} 126.13%)`
  }
}

export const BarBackground = styled.div`
  height: 6px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
  background: ${lightGray};
  transition: opacity 0.2s ease;
`

export const Bar = styled.div<{$progress: number; $animationIndex?: number; $status?: string}>`
  height: 100%;
  width: ${({$progress}): string => `${$progress}%`};
  ${({$progress}): string =>
    $progress < 100
      ? `
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;`
      : ''};
  background: ${backgroundColor};
  transition: width 300ms ease-in;
  ${({$animationIndex}): string =>
    $animationIndex ? `transition-delay: ${$animationIndex * 300 - 100}ms;` : ''}
`
